import React, { Component } from 'react';
import { observer } from 'mobx-react';

//styles
import styles from './OurServices.module.scss';

import { Container } from 'common/components/Layout/Layout';

import { injectIntl } from 'react-intl';

import messages from './OurServices.intl';

import ServiceBox from './ServiceBox/ServiceBox';

import ServicesStore from 'stores/Services.store';

@injectIntl
@observer
export default class Services extends Component {
  componentDidMount() {
    ServicesStore.fetchServices();
  }

  render() {
    const { services } = ServicesStore;
    return (
      ServicesStore.isLoaded() && (
        <Container className={styles.Container}>
          <h2 className={styles.HeaderTitle}>
            {this.props.intl.formatMessage(messages.heading)}
          </h2>
          <div className={styles.ServicesWrapper}>
            {services.map(item => <ServiceBox key={item.id} service={item} />)}
          </div>
        </Container>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/OurServices/OurServices.js